/**
 * «Где я?» и «Угадай язык» — страница /guess-the-country.
 *
 * Те же места и записи, что у голосовых игр Игротеки (колонка и голосовой
 * режим сайта), но с картой мира: человек слушает 15–25 секунд записи,
 * отмечает место кликом или пишет город/страну, и линия на карте показывает
 * промах. Очки — та же кривая, что у колонки: 5000 · e^(−км/1500), ближе 25 км —
 * 5000 (App\Services\VoiceGames\WorldSounds\GeoScore). Подсказка — часть света,
 * раунд стоит ×0,8.
 *
 * Звук дня: одно место на день для всех (по локальной дате устройства), шаг
 * 7919 по кругу мест — без повторов, пока не пройдёт весь круг.
 *
 * «Угадай язык»: 8 раундов, 3 или 6 вариантов; язык страницы не загадывается
 * (на ru-странице угадывать русский — не игра). Родственный язык на трудном
 * уровне — пол-очка.
 *
 * Данные — JSON в #gtcData (блейд), подписи — оттуда же: ни одной строки для
 * человека в этом файле.
 */
(function () {
    'use strict';

    var root = document.getElementById('gtc');
    var dataEl = document.getElementById('gtcData');
    if (!root || !dataEl) return;

    var D;
    try { D = JSON.parse(dataEl.textContent || '{}'); } catch (e) { return; }
    var T = D.ui || {};
    var LOC = D.locale || 'en';
    var nf;
    try { nf = new Intl.NumberFormat(LOC); } catch (e) { nf = { format: function (n) { return String(n); } }; }

    function $(id) { return document.getElementById(id); }
    function t(key, vars) {
        var s = String(T[key] || '');
        if (vars) {
            Object.keys(vars).sort(function (a, b) { return b.length - a.length; }).forEach(function (k) {
                s = s.split(':' + k).join(String(vars[k]));
            });
        }
        return s;
    }
    function fmt(n) { return nf.format(n); }
    /* «Город, страна»: у арабского своя запятая. */
    var SEP = LOC === 'ar' ? '، ' : ', ';
    function el(tag, cls, text) {
        var x = document.createElement(tag);
        if (cls) x.className = cls;
        if (text != null) x.textContent = text;
        return x;
    }
    function shuffle(a) {
        for (var i = a.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var x = a[i]; a[i] = a[j]; a[j] = x;
        }
        return a;
    }
    function announce(msg) { try { if (window.__announce) window.__announce(msg); } catch (e) {} }
    function store(key, val) {
        try {
            if (val === undefined) return JSON.parse(localStorage.getItem(key) || 'null');
            localStorage.setItem(key, JSON.stringify(val));
        } catch (e) {}
        return null;
    }
    function complete(payload) { try { if (window.__aeToolComplete) window.__aeToolComplete(payload); } catch (e) {} }
    function feature(f, data) {
        try { if (window.__ae) window.__ae('feature_use', Object.assign({ f: f }, data || {})); } catch (e) {}
    }
    /* Кнопка, которая на этом шаге не работает, — aria-disabled, а не disabled:
       выключенная кнопка теряет фокус, и человек с экранным диктором
       оказывается в начале страницы. */
    function setOff(btn, off) {
        btn.setAttribute('aria-disabled', off ? 'true' : 'false');
        btn.classList.toggle('is-off', !!off);
    }
    function isOff(btn) { return btn.getAttribute('aria-disabled') === 'true'; }
    /* Итог раунда — диктору вслух, а фокус — на «Дальше»: кнопка, на которой он
       стоял, выключена, и без переноса фокус уходит в начало документа. */
    function landOn(btn, say) {
        announce(say);
        try { btn.focus({ preventScroll: true }); } catch (e) {}
    }

    /* ── Очки: одна кривая с колонкой ───────────────────────────────── */
    var MAX = 5000, EXACT_KM = 25;
    function km(aLat, aLng, bLat, bLng) {
        var r = Math.PI / 180, dLat = (bLat - aLat) * r, dLng = (bLng - aLng) * r;
        var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(aLat * r) * Math.cos(bLat * r) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
        return 6371 * 2 * Math.asin(Math.min(1, Math.sqrt(h)));
    }
    function points(d) { return d <= EXACT_KM ? MAX : Math.round(MAX * Math.exp(-d / 1500)); }

    /* ── Плеер: один на панель ───────────────────────────────────────── */
    function Player(prefix) {
        this.prefix = prefix;
        this.heard = false;
        this.btn = $(prefix + 'Play');
        this.again = $(prefix + 'Replay');
        this.bar = $(prefix + 'Prog');
        this.msg = $(prefix + 'AudioMsg');
        this.audio = new Audio();
        this.audio.preload = 'none';
        this.src = '';
        var self = this;
        this.btn.addEventListener('click', function () { self.toggle(); });
        this.again.addEventListener('click', function () { self.restart(); });
        this.audio.addEventListener('timeupdate', function () {
            var d = self.audio.duration;
            if (d > 0 && isFinite(d)) self.bar.style.width = Math.min(100, self.audio.currentTime / d * 100) + '%';
        });
        this.audio.addEventListener('playing', function () { self.msg.textContent = ''; self.paint(true); });
        this.audio.addEventListener('pause', function () { self.paint(false); });
        this.audio.addEventListener('ended', function () { self.paint(false); self.bar.style.width = '100%'; });
        this.audio.addEventListener('waiting', function () { self.msg.textContent = t('loading'); });
        this.audio.addEventListener('error', function () {
            if (self.src) { self.msg.textContent = t('audio_error'); self.paint(false); }
        });
    }
    Player.prototype.load = function (src) {
        this.stop();
        this.heard = false;
        this.src = src;
        this.audio.src = src;
        this.bar.style.width = '0';
        this.msg.textContent = '';
    };
    Player.prototype.paint = function (on) {
        this.btn.textContent = (on ? '⏸ ' : '▶ ') + t(on ? 'pause' : 'play');
    };
    Player.prototype.toggle = function () {
        if (!this.src) return;
        if (this.audio.paused) {
            var self = this;
            /* Отказ говорит сама страница — строкой у плеера («звук не загрузился»).
               Через переднюю дверь тихо: иначе ядро добавило бы второй тост про
               «другой файл», которого у игры нет. Пауза поверх play (AbortError)
               ошибки на элементе не оставляет и отказом не считается. */
            var go = window.__safePlay ? window.__safePlay(this.audio, { quiet: true }) : this.audio.play();
            if (go && go.then) go.then(function (ok) {
                if (ok === false && self.audio.error) self.msg.textContent = t('audio_error');
            }, function (e) { if (e && e.name !== 'AbortError') self.msg.textContent = t('audio_error'); });
            if (!this.heard) { this.heard = true; feature(this.prefix + '_listen'); }
        } else {
            this.audio.pause();
        }
    };
    Player.prototype.restart = function () {
        if (!this.src) return;
        try { this.audio.currentTime = 0; } catch (e) {}
        if (this.audio.paused) this.toggle();
    };
    Player.prototype.stop = function () {
        try { this.audio.pause(); } catch (e) {}
    };

    /* ── Вкладки ─────────────────────────────────────────────────────── */
    var tabs = [$('gtcTabWhere'), $('gtcTabLang')];
    var panels = [$('gtcWhere'), $('gtcLang')];
    var whereP, langP, map, booted = false;
    function select(i) {
        tabs.forEach(function (tab, k) {
            var on = k === i;
            tab.classList.toggle('is-on', on);
            tab.setAttribute('aria-selected', on ? 'true' : 'false');
            tab.tabIndex = on ? 0 : -1;
            panels[k].hidden = !on;
        });
        if (whereP) whereP.stop();
        if (langP) langP.stop();
        if (i === 0 && map) setTimeout(function () { map.invalidateSize(); }, 50);
        if (i === 1 && !L1.order.length) langNew();
        store('gtc_tab', i);
        if (booted) feature('gtc_tab', { tab: i === 1 ? 'language' : 'where' });
    }
    tabs.forEach(function (tab, k) {
        tab.addEventListener('click', function () { select(k); });
        tab.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
                var n = (k + 1) % 2;
                select(n);
                tabs[n].focus({ preventScroll: true });
                e.preventDefault();
            }
        });
    });

    /* ══════════════════════ «Где я?» ══════════════════════ */
    var PLACES = D.places || [];
    var ROUNDS = D.rounds || 5;
    var W = { order: [], i: 0, total: 0, hint: false, guess: null, revealed: false, daily: false, log: [] };
    var layers = [];

    function initMap() {
        if (map || !window.L || !$('gtcMap')) return;
        map = L.map('gtcMap', { worldCopyJump: true, minZoom: 1, maxZoom: 12, zoomControl: true });
        if (window.__mapTiles) {
            window.__mapTiles.base(L, map, null, { slug: 'guess-the-country', style: 'auto', control: false, opts: { maxZoom: 12 } });
        } else if (window.__basemapFallback) {
            window.__basemapFallback(L, map, '');
        }
        map.setView([25, 10], 2);
        map.on('click', function (e) {
            if (W.revealed || !W.order.length) return;
            var ll = e.latlng.wrap();
            setGuess(ll.lat, ll.lng, null, 'map');
        });
    }
    function clearLayers() {
        if (!map) return;
        layers.forEach(function (l) { map.removeLayer(l); });
        layers = [];
    }
    function pin(lat, lng, cls, title) {
        var icon = L.divIcon({ className: '', html: '<div class="gtc-pin ' + cls + '"></div>', iconSize: [18, 18], iconAnchor: [9, 9] });
        var m = L.marker([lat, lng], { icon: icon, keyboard: false, title: title });
        m.addTo(map);
        layers.push(m);
        return m;
    }
    function setGuess(lat, lng, name, via) {
        W.guess = { lat: lat, lng: lng, name: name, via: via || 'text' };
        clearLayers();
        if (map) pin(lat, lng, 'you', t('you'));
        $('gtcGuess').disabled = false;
        var line = name ? t('picked', { name: name }) : t('picked_point');
        $('gtcTextMsg').textContent = line;
        $('gtcTextMsg').classList.remove('is-warn');
        announce(t('sr_marked', { name: name || '' }));
    }

    function placeByKey(key) {
        for (var i = 0; i < PLACES.length; i++) if (PLACES[i].key === key) return PLACES[i];
        return null;
    }

    function pickOrder() {
        var recent = store('gtc_recent') || [];
        var keys = shuffle(PLACES.map(function (p) { return p.key; }));
        keys.sort(function (a, b) { return (recent.indexOf(a) >= 0) - (recent.indexOf(b) >= 0); });
        var order = [], seen = {};
        keys.forEach(function (k) {
            var cc = placeByKey(k).cc;
            if (order.length < ROUNDS && !seen[cc]) { order.push(k); seen[cc] = 1; }
        });
        store('gtc_recent', order.concat(recent).slice(0, 25));
        return order;
    }

    function today() {
        var d = new Date();
        return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    }
    function dailyKey() {
        var d = new Date();
        var day = Math.floor(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()) / 86400000);
        var keys = PLACES.map(function (p) { return p.key; }).sort();
        return keys[(day * 7919) % keys.length];
    }

    function whereNew(daily) {
        W = { order: daily ? [dailyKey()] : pickOrder(), i: 0, total: 0, hint: false, guess: null, revealed: false, daily: !!daily, log: [] };
        $('gtcFinal').hidden = true;
        $('gtcDaily').classList.toggle('is-on', !!daily);
        $('gtcDaily').setAttribute('aria-pressed', daily ? 'true' : 'false');
        var note = $('gtcDailyNote');
        note.hidden = !daily;
        if (daily) note.textContent = t('daily_title', { date: today() }) + '. ' + t('daily_note');
        whereRound();
    }

    function whereRound() {
        var p = placeByKey(W.order[W.i]);
        W.hint = false; W.guess = null; W.revealed = false;
        clearLayers();
        if (map) map.setView([25, 10], 2);
        whereP.load(p.src);
        $('gtcRound').textContent = W.daily ? t('daily') : t('round', { n: W.i + 1, total: W.order.length });
        $('gtcScore').textContent = t('score', { score: fmt(W.total) });
        $('gtcResult').hidden = true;
        $('gtcGuess').disabled = true;
        setOff($('gtcHint'), false);
        $('gtcGiveUp').disabled = false;
        $('gtcText').value = '';
        $('gtcTextMsg').textContent = '';
    }

    function arc(a, b) {
        var pts = [], r = Math.PI / 180;
        var lat1 = a.lat * r, lng1 = a.lng * r, lat2 = b.lat * r, lng2 = b.lng * r;
        var d = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin((lat2 - lat1) / 2), 2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin((lng2 - lng1) / 2), 2)));
        if (d < 1e-6) return [[a.lat, a.lng], [b.lat, b.lng]];
        for (var i = 0; i <= 48; i++) {
            var f = i / 48, A = Math.sin((1 - f) * d) / Math.sin(d), B = Math.sin(f * d) / Math.sin(d);
            var x = A * Math.cos(lat1) * Math.cos(lng1) + B * Math.cos(lat2) * Math.cos(lng2);
            var y = A * Math.cos(lat1) * Math.sin(lng1) + B * Math.cos(lat2) * Math.sin(lng2);
            var z = A * Math.sin(lat1) + B * Math.sin(lat2);
            pts.push([Math.atan2(z, Math.sqrt(x * x + y * y)) / r, Math.atan2(y, x) / r]);
        }
        for (var k = 1; k < pts.length; k++) {
            while (pts[k][1] - pts[k - 1][1] > 180) pts[k][1] -= 360;
            while (pts[k][1] - pts[k - 1][1] < -180) pts[k][1] += 360;
        }
        return pts;
    }

    function whereReveal(skip) {
        if (W.revealed) return;
        var p = placeByKey(W.order[W.i]);
        var g = W.guess;
        var d = (!skip && g) ? km(g.lat, g.lng, p.lat, p.lng) : null;
        var got = d === null ? 0 : Math.round(points(d) * (W.hint ? 0.8 : 1));
        W.revealed = true;
        W.total += got;
        W.log.push({ key: p.key, points: got });
        whereP.stop();

        clearLayers();
        if (map) {
            var ans = pin(p.lat, p.lng, 'answer', t('answer_marker'));
            ans.bindTooltip(p.name, { direction: 'top', offset: [0, -8] });
            if (g && !skip) {
                pin(g.lat, g.lng, 'you', t('you'));
                var line = L.polyline(arc(g, p), { color: '#f0910a', weight: 3, dashArray: '6 6', opacity: .9 }).addTo(map);
                layers.push(line);
                map.fitBounds(line.getBounds(), { padding: [40, 40], maxZoom: 6 });
            } else {
                map.setView([p.lat, p.lng], 4);
            }
        }

        var lead = skip ? 'result_skip'
            : d <= EXACT_KM ? 'result_exact'
            : got >= 4500 ? 'result_great'
            : got >= 3000 ? 'result_good'
            : got >= 1000 ? 'result_ok' : 'result_far';
        var box = $('gtcResult');
        box.innerHTML = '';
        box.appendChild(el('h3', null, t(lead)));
        var where = p.name + (p.country && p.country !== p.name ? SEP + p.country : '') + ' — ' + p.scene;
        box.appendChild(el('p', null, t('result_answer', { place: where })));
        box.appendChild(el('p', 'gtc-big', skip ? t('result_skip_line') : t('result_line', { km: fmt(Math.round(d)), points: fmt(got) })));
        var cr = el('p', 'gtc-credit');
        var a = el('a', null, t('credit_place', { title: p.credit.title, author: p.credit.author }));
        a.href = p.credit.url; a.target = '_blank'; a.rel = 'noopener nofollow';
        cr.appendChild(a);
        box.appendChild(cr);
        var last = W.i + 1 >= W.order.length;
        var next = el('button', 'gtc-primary', last ? t('finish') : t('next'));
        next.type = 'button';
        next.addEventListener('click', function () {
            if (last) { whereFinish(); } else { W.i++; whereRound(); $('gtcPlay').focus({ preventScroll: true }); }
        });
        box.appendChild(next);
        box.hidden = false;
        $('gtcScore').textContent = t('score', { score: fmt(W.total) });
        $('gtcGuess').disabled = true;
        setOff($('gtcHint'), true);
        $('gtcGiveUp').disabled = true;
        landOn(next, t(lead) + ' ' + t('result_answer', { place: where }) + ' ' + (skip ? t('result_skip_line') : t('result_line', { km: fmt(Math.round(d)), points: fmt(got) })));
        if (skip) feature('gtc_giveup', { round: W.i + 1, hint: W.hint ? 1 : 0 });
        else feature('gtc_guess', { round: W.i + 1, via: g.via, hint: W.hint ? 1 : 0, km: Math.round(d), points: got, daily: W.daily ? 1 : 0 });
    }

    function whereFinish() {
        var box = $('gtcFinal');
        box.innerHTML = '';
        $('gtcResult').hidden = true;
        var max = W.order.length * MAX;
        box.appendChild(el('h3', null, t('final_title', { score: fmt(W.total), max: fmt(max) })));
        if (!W.daily) {
            var share = W.total / max;
            box.appendChild(el('p', null, t(share >= 0.8 ? 'verdict_4' : share >= 0.56 ? 'verdict_3' : share >= 0.32 ? 'verdict_2' : 'verdict_1')));
            var ol = el('ol', 'gtc-rows');
            W.log.forEach(function (r) {
                var p = placeByKey(r.key);
                ol.appendChild(el('li', null, p.name + (p.country && p.country !== p.name ? SEP + p.country : '') + ' — +' + fmt(r.points)));
            });
            box.appendChild(ol);
        } else {
            store('gtc_daily', { date: today(), score: W.total });
            var copy = el('button', 'gtc-ghost', t('copy_result'));
            copy.type = 'button';
            copy.addEventListener('click', function () {
                var text = t('share_text', { date: today(), score: fmt(W.total) }) + ' ' + location.href.split('#')[0];
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(text).then(function () { copy.textContent = t('copied'); }, function () {});
                }
            });
            box.appendChild(copy);
            box.appendChild(document.createTextNode(' '));
        }
        var again = el('button', 'gtc-primary', t('again'));
        again.type = 'button';
        again.addEventListener('click', function () { whereNew(false); $('gtcPlay').focus({ preventScroll: true }); });
        box.appendChild(again);
        box.hidden = false;
        landOn(again, t('final_title', { score: fmt(W.total), max: fmt(max) }));
        complete({ t: W.daily ? 'gtc_daily' : 'gtc_game', mode: W.daily ? 'daily' : 'where', score: W.total, rounds: W.order.length });
    }

    /* ── Ответ текстом: страна из списка или город из справочника GeoNames ── */
    var COUNTRIES = (D.countries || []).map(function (c) { return { cc: c[0], name: c[1], n: normalize(c[1]), lat: c[2], lng: c[3] }; });
    function normalize(s) {
        s = String(s || '').toLowerCase().replace(/ё/g, 'е');
        if (s.normalize) s = s.normalize('NFKD').replace(/[̀-ͯ]/g, '');
        return s.replace(/[\s.,!?;:«»"“”„()\[\]{}…'’`\-–—\/]+/g, ' ').trim();
    }
    function findCountry(q, prefix) {
        var n = normalize(q);
        if (!n) return null;
        for (var i = 0; i < COUNTRIES.length; i++) if (COUNTRIES[i].n === n) return COUNTRIES[i];
        if (prefix) {
            var hits = COUNTRIES.filter(function (c) { return c.n.indexOf(n) === 0; });
            if (hits.length === 1) return hits[0];
        }
        return null;
    }
    var citiesReady = null;
    function cities() {
        if (!citiesReady && window.LocationInput && window.LocationInput.loadData) {
            var msg = $('gtcTextMsg'), loading = t('text_loading');
            /* Пока справочник грузится, человек успевает отметить страну — «загрузка
               закончилась» не должна стирать «Ваша догадка: …». */
            if (!msg.textContent) msg.textContent = loading;
            var done = function () { if (msg.textContent === loading) msg.textContent = ''; };
            citiesReady = window.LocationInput.loadData().then(function () { done(); return true; }, function () { done(); citiesReady = null; return false; });
        }
        return citiesReady || Promise.resolve(false);
    }
    function cityHits(q, limit) {
        var LI = window.LocationInput;
        if (!LI || !LI.getData || !LI.getData()) return [];
        return (LI.search(q, limit) || []).map(function (h) { return LI.rowToCity(h.i); });
    }
    var sugTimer = 0;
    $('gtcText').addEventListener('focus', function () { cities(); });
    $('gtcText').addEventListener('input', function () {
        clearTimeout(sugTimer);
        var q = this.value;
        sugTimer = setTimeout(function () {
            var list = $('gtcSuggest');
            list.innerHTML = '';
            var n = normalize(q);
            if (n.length < 2) return;
            var seen = {};
            COUNTRIES.filter(function (c) { return c.n.indexOf(n) === 0; }).slice(0, 4).forEach(function (c) {
                if (seen[c.name]) return;
                seen[c.name] = 1;
                var o = document.createElement('option'); o.value = c.name; list.appendChild(o);
            });
            cityHits(q, 6).forEach(function (c) {
                var label = c.name + (c.cc ? ' (' + c.cc + ')' : '');
                if (seen[label]) return;
                seen[label] = 1;
                var o = document.createElement('option'); o.value = label; list.appendChild(o);
            });
        }, 180);
    });
    /* Enter в поле с подсказками (datalist) Safari отдаёт списку и форму не
       отправляет — догадка молча не ставилась. Если за Enter отправки не было,
       отправляем сами; IME (корейский, японский) Enter'ом подтверждает слог. */
    var enterPending = false;
    $('gtcText').addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' || e.isComposing || e.keyCode === 229) return;
        enterPending = true;
        setTimeout(function () { if (enterPending) { enterPending = false; submitText(); } }, 80);
    });
    $('gtcTextForm').addEventListener('submit', function (e) {
        e.preventDefault();
        enterPending = false;
        submitText();
    });
    function submitText() {
        if (W.revealed) return;
        var raw = $('gtcText').value.trim();
        if (!raw) return;
        var q = raw.replace(/\s*\([A-Z]{2}\)\s*$/, '');
        var c = findCountry(q, true);
        if (c) {
            setGuess(c.lat, c.lng, c.name);
            if (map) map.setView([c.lat, c.lng], 4);
            return;
        }
        cities().then(function () {
            var hit = cityHits(q, 1)[0];
            if (hit) {
                setGuess(hit.lat, hit.lng, hit.name);
                if (map) map.setView([hit.lat, hit.lng], 6);
            } else {
                $('gtcTextMsg').textContent = t('text_not_found', { q: raw });
                $('gtcTextMsg').classList.add('is-warn');
                feature('gtc_text_miss', { q: raw.slice(0, 40) });
            }
        });
    }

    $('gtcGuess').addEventListener('click', function () { if (W.guess) whereReveal(false); });
    $('gtcGiveUp').addEventListener('click', function () { whereReveal(true); });
    $('gtcHint').addEventListener('click', function () {
        if (W.hint || W.revealed || isOff(this)) return;
        W.hint = true;
        var p = placeByKey(W.order[W.i]);
        $('gtcTextMsg').textContent = t('hint_shown', { continent: (D.continents || {})[p.ct] || p.ct, max: fmt(MAX * 0.8) });
        $('gtcTextMsg').classList.remove('is-warn');
        setOff(this, true);
        feature('gtc_hint', { round: W.i + 1 });
    });
    $('gtcDaily').addEventListener('click', function () {
        var done = store('gtc_daily');
        if (done && done.date === today()) {
            var note = $('gtcDailyNote');
            note.hidden = false;
            note.textContent = t('daily_done', { score: fmt(done.score) });
            return;
        }
        whereNew(!W.daily);
        feature('gtc_daily', { on: W.daily ? 1 : 0 });
    });

    /* ══════════════════════ «Угадай язык» ══════════════════════ */
    var LANGS = (D.langs || []).filter(function (l) { return l.code !== LOC; });
    var LROUNDS = D.langRounds || 8;
    var L1 = { order: [], i: 0, score: 0, level: 'easy', opts: [], hint: false, answered: false };
    function langBy(code) { for (var i = 0; i < LANGS.length; i++) if (LANGS[i].code === code) return LANGS[i]; return null; }

    function langNew() {
        var level = L1.level;
        var codes = shuffle(LANGS.map(function (l) { return l.code; })).slice(0, LROUNDS);
        L1 = { order: codes.map(function (c) { var l = langBy(c); return { code: c, clip: l.clips[Math.floor(Math.random() * l.clips.length)] }; }), i: 0, score: 0, level: level, opts: [], hint: false, answered: false };
        $('gtlFinal').hidden = true;
        langRound();
    }
    function options(code, n) {
        var me = langBy(code);
        var others = LANGS.filter(function (l) { return l.code !== code; });
        var near = shuffle(others.filter(function (l) { return l.family === me.family || l.area === me.area; }));
        var rest = shuffle(others.filter(function (l) { return near.indexOf(l) < 0; }));
        var pick = [code];
        near.slice(0, n === 3 ? 1 : 2).forEach(function (l) { pick.push(l.code); });
        rest.forEach(function (l) { if (pick.length < n) pick.push(l.code); });
        near.forEach(function (l) { if (pick.length < n && pick.indexOf(l.code) < 0) pick.push(l.code); });
        return shuffle(pick);
    }
    function langRound() {
        var r = L1.order[L1.i];
        L1.opts = options(r.code, L1.level === 'easy' ? 3 : 6);
        L1.hint = false; L1.answered = false;
        langP.load(r.clip.src);
        $('gtlRound').textContent = t('round', { n: L1.i + 1, total: L1.order.length });
        $('gtlScore').textContent = t('score', { score: fmt(L1.score) });
        $('gtlResult').hidden = true;
        setOff($('gtlHint'), false);
        $('gtlGiveUp').disabled = false;
        drawOptions();
    }
    function drawOptions() {
        var box = $('gtlOpts');
        box.innerHTML = '';
        L1.opts.forEach(function (code) {
            var b = el('button', 'gtc-opt', langBy(code).name);
            b.type = 'button';
            b.setAttribute('data-code', code);
            b.addEventListener('click', function () { langAnswer(code); });
            box.appendChild(b);
        });
    }
    function langAnswer(said) {
        if (L1.answered) return;
        L1.answered = true;
        langP.stop();
        var r = L1.order[L1.i], right = langBy(r.code);
        var close = said && said !== r.code && L1.level === 'hard' && langBy(said).family === right.family;
        var gain = said === r.code ? (L1.hint ? 0.5 : 1) : (close && !L1.hint ? 0.5 : 0);
        L1.score += gain;
        Array.prototype.forEach.call($('gtlOpts').children, function (b) {
            var c = b.getAttribute('data-code');
            b.disabled = true;
            if (c === r.code) b.classList.add('is-right');
            else if (c === said) b.classList.add('is-wrong');
        });
        var box = $('gtlResult');
        box.innerHTML = '';
        var lead = !said ? 'lang_skip' : said === r.code ? 'lang_right' : close ? 'lang_close' : 'lang_wrong';
        box.appendChild(el('h3', null, t(lead)));
        box.appendChild(el('p', 'gtc-big', t('lang_answer', { name: right.name })));
        box.appendChild(el('p', null, right.fact));
        if (r.clip.text) box.appendChild(el('p', 'gtc-credit', t('lang_text', { text: r.clip.text })));
        var lc = el('p', 'gtc-credit');
        var la = el('a', null, t('lang_credit'));
        la.href = D.fleurs || 'https://huggingface.co/datasets/google/fleurs'; la.target = '_blank'; la.rel = 'noopener nofollow';
        lc.appendChild(la);
        box.appendChild(lc);
        var last = L1.i + 1 >= L1.order.length;
        var next = el('button', 'gtc-primary', last ? t('finish') : t('next'));
        next.type = 'button';
        next.addEventListener('click', function () {
            if (last) { langFinish(); } else { L1.i++; langRound(); $('gtlPlay').focus({ preventScroll: true }); }
        });
        box.appendChild(next);
        box.hidden = false;
        $('gtlScore').textContent = t('score', { score: fmt(L1.score) });
        setOff($('gtlHint'), true);
        $('gtlGiveUp').disabled = true;
        landOn(next, t(lead) + ' ' + t('lang_answer', { name: right.name }));
        feature('gtl_answer', { round: L1.i + 1, level: L1.level, right: said === r.code ? 1 : 0, close: close ? 1 : 0, skip: said ? 0 : 1, hint: L1.hint ? 1 : 0, lang: r.code });
    }
    function langFinish() {
        var box = $('gtlFinal');
        box.innerHTML = '';
        $('gtlResult').hidden = true;
        box.appendChild(el('h3', null, t('lang_final_title', { score: fmt(L1.score), max: fmt(L1.order.length) })));
        var share = L1.score / L1.order.length;
        box.appendChild(el('p', null, t(share >= 0.85 ? 'lang_verdict_4' : share >= 0.6 ? 'lang_verdict_3' : share >= 0.35 ? 'lang_verdict_2' : 'lang_verdict_1')));
        var again = el('button', 'gtc-primary', t('again'));
        again.type = 'button';
        again.addEventListener('click', function () { langNew(); $('gtlPlay').focus({ preventScroll: true }); });
        box.appendChild(again);
        box.hidden = false;
        landOn(again, t('lang_final_title', { score: fmt(L1.score), max: fmt(L1.order.length) }));
        complete({ t: 'gtl_game', mode: 'language', level: L1.level, score: L1.score, rounds: L1.order.length });
    }
    $('gtlHint').addEventListener('click', function () {
        if (L1.hint || L1.answered || isOff(this)) return;
        var code = L1.order[L1.i].code;
        var wrong = L1.opts.filter(function (c) { return c !== code; });
        if (!wrong.length) return;
        var drop = wrong[Math.floor(Math.random() * wrong.length)];
        L1.opts = L1.opts.filter(function (c) { return c !== drop; });
        L1.hint = true;
        drawOptions();
        setOff(this, true);
        $('gtlAudioMsg').textContent = t('lang_hint_done');
        feature('gtl_hint', { round: L1.i + 1, level: L1.level });
    });
    $('gtlGiveUp').addEventListener('click', function () { langAnswer(null); });
    function setLevel(level) {
        L1.level = level;
        $('gtlEasy').setAttribute('aria-pressed', level === 'easy' ? 'true' : 'false');
        $('gtlHard').setAttribute('aria-pressed', level === 'hard' ? 'true' : 'false');
        store('gtc_level', level);
        feature('gtl_level', { level: level });
        langNew();
    }
    $('gtlEasy').addEventListener('click', function () { if (L1.level !== 'easy' || !L1.order.length) setLevel('easy'); });
    $('gtlHard').addEventListener('click', function () { if (L1.level !== 'hard' || !L1.order.length) setLevel('hard'); });

    /* ── Старт ───────────────────────────────────────────────────────── */
    whereP = new Player('gtc');
    langP = new Player('gtl');
    var savedLevel = store('gtc_level');
    if (savedLevel === 'hard') {
        L1.level = 'hard';
        $('gtlEasy').setAttribute('aria-pressed', 'false');
        $('gtlHard').setAttribute('aria-pressed', 'true');
    }
    function boot() {
        initMap();
        whereNew(false);
        if (store('gtc_tab') === 1) select(1);
        booted = true;
    }
    if (window.L) boot();
    else window.addEventListener('load', boot, { once: true });
})();
